import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPayment.Cancel.IRequest;
type Response = Api.Finance.ClaimJobPayment.Cancel.IResponse;
type Headers = Api.Finance.ClaimJobPayment.Cancel.IHeaders;
const url = '/api/Finance/ClaimJobPayment/:id/Cancel';
export default async function claimJobPaymentCancelApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
